import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_AWS_IMAGE } from '../../config/url.servicio'

@Injectable()
export class ProductosProvider {
  token:string

  constructor(public http: Http, private storage: Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
    });
  }

  buscar() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name=productos`);
    } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=productos`)
    .map((data) => data.json())
  }
  }

  buscarProductoCompania(companias:any) {
    let url = URL_SERVICIOS_LOCALES
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarProductoCompania",
        parameters : {companiasId: companias}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let valor = parseInt(companias)
    return this.http.get(`${url}/proceso/buscarProductoCompania?companiasId=${valor}`)
    .map((data) => data.json())
  }
  }

  buscarEgresosDiariosCompania(companias:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarEgresosDiariosCompania",
      parameters : {companiasId: companias}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }



  guardar(values: any, typeImg) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {
                      ...values
                    }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  guardarImagen(producto: any, typeImg: any) {
    var data = new FormData();
    data.append('file', producto.imagen)
    let url_servicio_aws_image = URL_SERVICIOS_AWS_IMAGE
    return this.http.post(`${url_servicio_aws_image}/dev/image-upload`, data)
      .map((data) =>  data.json())
  }

  guardarProducto(productos: any, nombretabla: string = "productos") {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "dataDynamicCrud",
        parameters : {...productos, nombreTabla: nombretabla}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })
    return this.http.post(`${url}/query`, productos, options)
      .map((data) => data.json())
  }
  }

  editar(producto, typeImg) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {...producto}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      var data = new FormData();
      data.append('codigoProducto', producto.codigoProducto)
      data.append('nombreProducto', producto.nombreProducto)
      data.append('descripcion', producto.descripcion)
      // verificar si se modifico el producto
      try {
        if( producto.imagen.indexOf('http') > -1 ){
          data.append('imagen', producto.imagen)
        } else {
          data.append('imagen', new Blob([producto.imagen], {type: typeImg}))
        }
      } catch (error) {
        data.append('imagen', new Blob([producto.imagen], {type: typeImg}))
      }

      data.append('costo', producto.costo)
      data.append('valorVenta', producto.valorVenta)
      data.append('existenciasMinimas', producto.existenciasMinimas)
      data.append('existenciasActuales', producto.existenciasActuales)
      data.append('visualizaEnCaja', producto.visualizaEnCaja)
      data.append('controlaEnInventario', producto.controlaEnInventario)
      data.append('companiasId', producto.companiasId)
      data.append('productosId', producto.productosId)
      data.append('tipoImpuesto', producto.tipoImpuesto)
      data.append('valorImpuesto', producto.valorImpuesto)
      data.append('centroDeCostosId', producto.centroDeCostosId)
      data.append('codigoBarra', producto.codigoBarra)

      return this.http.put(`${url}/producto`, data, options)
        .map((data) => data.json())
   }
  }

  eliminarEgresosIngresos(values: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: values.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          egresosDiariosId : values.egresosDiariosId,
          nombreTabla: "egresosDiarios"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
 }

  eliminar(producto: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosId : producto.productosId,
          nombreTabla: "productos"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosId=${producto.productosId}&nombreTabla=productos`, options)
  }
 }

 eliminarCualquierProducto(producto: any, tipo:string) {

    let url_servicio = URL_SERVICIOS_AWS;
    let data = {}
    if(tipo === 'P') {
      data = {
        name: "dataDynamicCrud",
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosId : producto.productosId,
          nombreTabla: "productos"
        }
      }
    } else {
      data = {
        name: "dataDynamicCrud",
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          productosElaboradosId : producto.productosId,
          nombreTabla: "productosElaborados"
        }
      }
    }

    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
}

 migrarProductosBase(datosMigrar:any, companiasId:any){
    const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "migrarProductosBase",
      parameters : {  datosMigrar: JSON.stringify(datosMigrar),
        companiasId: Number(companiasId)
        }
    }
    console.log(data)

    let headers = new Headers({ 'Content-Type': 'application/json'})
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options)
}

async buscarProductosCamposAdicionales(companiasId: any,productosId:any,tipo:any) {
  const url_servicio = URL_SERVICIOS_AWS;
  const data = {
    name: "buscarProductosCamposAdicionales",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId,
      tipo:tipo
    }
  };

  const headers = new Headers({ 'Content-Type': 'application/json' });
  const options = new RequestOptions({ headers: headers });

  try {
    const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en buscarProductosCamposAdicionales:', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

async actualizarProductosCamposAdicionalesValores(companiasId:any,productosId:any,tipo:any,valor:any,nombre:any,tieneProductoRapido:any) {
  const url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "actualizarProductosCamposAdicionalesValores",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId,
      tipo:tipo,
      valor:valor,
      nombre:nombre,
      tieneProductoRapido:tieneProductoRapido
    }
  };
  const headers = new Headers({ 'Content-Type': 'application/json' });
  const options = new RequestOptions({ headers: headers });

  try {
    const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en buscarProductosCamposAdicionales:', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

async actualizarProductosCamposAdicionalesEgresos(companiasId:any,productosId:any,tipo:any,egreso:any) {
  const url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: "actualizarProductosCamposAdicionalesEgresos",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId,
      tipo:tipo,
      egreso:egreso
    }
  };
  const headers = new Headers({ 'Content-Type': 'application/json' });
  const options = new RequestOptions({ headers: headers });

  try {
    const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en buscarProductosCamposAdicionales:', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}


async guardarProductoAsync(productos: any, nombretabla: string = "productos") {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "dataDynamicCrud",
      parameters : {...productos, nombreTabla: nombretabla}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    try {
      const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
      return response; // o puedes procesar la respuesta como desees
    } catch (error) {
      console.error('Error en buscarProductosCamposAdicionales:', error);
      throw error; // Lanza el error si deseas manejarlo externamente
    }
}

async buscarColores(companiasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarColores",
    parameters: {
      companiasId: Number(companiasId)
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

async buscarTallas(companiasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarTallas",
    parameters: {
      companiasId: Number(companiasId)
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

async guardarColor(companiasId: any,color:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "guardarColor",
    parameters: {
      companiasId: Number(companiasId),
      color:color
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

async guardarTalla(companiasId: any,talla:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "guardarTalla",
    parameters: {
      companiasId: Number(companiasId),
      talla:talla
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

buscarTodosLosProductos (text){
   const url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarTodosLosProductos",
      parameters : {companiasId: text}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    return this.http.post(`${url_servicio}/procedure`, data, options)
        .map((data: any) =>
         {
           let  dataNew = JSON.parse(data._body).data
           return dataNew[0].map((item, index) => {
              return {
                display: item.nombreProducto,
                value: item.productosId,
                tipo: item.tipo,
                existenciasActuales: item.existenciasActuales
            }})});
}

async buscarCompaniasTraslados(companiasId: any,uuid:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarCompaniasTraslados",
    parameters: {
      companiasId: Number(companiasId),
      uuid:uuid
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }

 async buscarUuidProductosTraslados(companiasId: any,productosId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarUuidProductosTraslados",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }

 async consultarProductosCoincidenOtrasCompanias(companiasId: any,marca:any,linea:any,referencia:any,talla:any,color:any,nombreProducto:any,categoria:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let filtrosProducto = {
    companiasId: Number(companiasId),
      marca:marca,
      linea:linea,
      referencia:referencia,
      talla:talla,
      color:color,
      nombreProducto:nombreProducto,
      categoria:categoria
  }
  let values = {
    name: "consultarProductosCoincidenOtrasCompanias",
    parameters: {
      filtrosProducto: JSON.stringify(filtrosProducto)
     }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }


 async buscarMorosos(companiasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarMorosos",
    parameters: {
      companiasId: Number(companiasId)
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }

 async actualizarValoresTraslado(actualizarValores: any,datosAdicionales:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "actualizarValoresTraslado",
    parameters: {
      actualizarValores: JSON.stringify(actualizarValores),
      datosAdicionales:JSON.stringify(datosAdicionales)
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }

 async buscarCamposBaseProducto(companiasId: any,productosId:any,tipo:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarCamposBaseProducto",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId,
      tipo:tipo
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }


 async gestionarProductosPorGrupos(val: any,codigoProducto:any,tipo:any,gruposProductosId:any,queHago:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "gestionarProductosPorGruposRapido",
    parameters: {
      companiasId: val,
      codigoProducto:codigoProducto,
      tipo:tipo,
      gruposProductosId:gruposProductosId,
      queHagoTwo:queHago
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response;
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }


 async buscarProductosValoresIca(companiasId: any,productosId:any,tipo:any) {
  const url_servicio = URL_SERVICIOS_AWS;
  const data = {
    name: "buscarProductosValoresIca",
    parameters: {
      companiasId: Number(companiasId),
      productosId:productosId,
      tipo:tipo
    }
  };

  const headers = new Headers({ 'Content-Type': 'application/json' });
  const options = new RequestOptions({ headers: headers });

  try {
    const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en buscarProductosCamposAdicionales:', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}


async buscarMensajeGeneral(companiasId: any,tipo:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let values = {
    name: "buscarMensajeGeneral",
    parameters: {
      companiasId: Number(companiasId),
      tipo:tipo
    }
  };
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  try {
    const response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en :', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
 }
 async buscarProductosExistente(companiasId: any,nombre:any) {
  const url_servicio = URL_SERVICIOS_AWS;
  const data = {
    name: "buscarProductosExistente",
    parameters: {
      companiasId: Number(companiasId),
      nombre:nombre
    }
  };

  const headers = new Headers({ 'Content-Type': 'application/json' });
  const options = new RequestOptions({ headers: headers });

  try {
    const response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
    return response; // o puedes procesar la respuesta como desees
  } catch (error) {
    console.error('Error en:', error);
    throw error; // Lanza el error si deseas manejarlo externamente
  }
}

buscarTodosLosProductosPaginados (text){
  const url_servicio = URL_SERVICIOS_AWS;
   let data = {
     name: "buscarTodosLosProductosPaginados",
     parameters : {companiasId: text}
   }
   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
   let options = new RequestOptions({ headers: headers }) // Create a request option

   return this.http.post(`${url_servicio}/procedure`, data, options)
       .map((data: any) =>
        {
          let  dataNew = JSON.parse(data._body).data
          return dataNew[0].map((item, index) => {
             return {
               display: item.nombreProducto,
               value: item.productosId,
               tipo: item.tipo,
               existenciasActuales: item.existenciasActuales
           }})});
}


}



// WEBPACK FOOTER //
// ./src/providers/productos/productos.ts